import { render, staticRenderFns } from "./Groups.vue?vue&type=template&id=4e9fd0d5"
import script from "./Groups.vue?vue&type=script&lang=js"
export * from "./Groups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports